var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConditionalLogicOnSbs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 27,
    rx: 2,
    fill: "#7BD5AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9v-.25c0-.206.169-.375.375-.375h3.306c.103 0 .203.044.275.122l2.803 3.031-.68.738-2.673-2.891H6.375A.376.376 0 016 9zm15.706 8.706l-2 2C19.078 20.334 18 19.887 18 19v-1.375h-.803a.375.375 0 01-.275-.122l-2.803-3.031.681-.738 2.669 2.891H18V15c0-.89 1.078-1.334 1.706-.706l2 2a.998.998 0 010 1.412zm-.619-.793l-2-2a.125.125 0 00-.212.087v4c0 .113.134.169.212.087l2-2a.12.12 0 000-.174zm.62-7.207l-2 2C19.077 12.334 18 11.887 18 11V9.375h-.531l-7.513 8.128a.375.375 0 01-.275.122H6.375A.376.376 0 016 17.25V17c0-.206.169-.375.375-.375h3.031l7.513-8.128a.374.374 0 01.275-.122H18V7c0-.89 1.078-1.334 1.706-.706l2 2a.998.998 0 010 1.412zm-.62-.794l-2-2a.125.125 0 00-.212.088v4c0 .113.134.169.212.088l2-2a.12.12 0 000-.176z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "./fonts/conditional-logic-on-sbs.59f176d34ed5d23d0996475ae2c06d12.svg";
export { SvgConditionalLogicOnSbs as ReactComponent };